import {
  GET_RACES, GET_RACE_DETAIL, GET_LEADERBOARD_MEN, GET_LEADERBOARD_WOMEN, TOGGLE_FAVORITE, GET_RESULTS, SET_BRAND,
  SELECT_EVENT, GET_RUNNER_RESULTS, SEARCH_RESULTS, SET_ACCOUNT_ID, SET_MOBILE, SWITCH_RACE, SET_ADS,
  CLEAR_SEARCH_RESULTS, SET_THEME, SET_SINGLE_EVENT, STICKY_FULL, CHANGE_SORT, UNAUTHORIZED
} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function rr360Reducer(state = initialState.rr360, action) {
  // let newState;

  switch (action.type) {

    case SWITCH_RACE:
      return objectAssign({}, state, {eventId: '', raceDetail: {}, searchResults: null, searchResultsTotal: null, searchResultsPage: 0, results: null, resultsTotal: null, resultsPage: 0, leadersMen: [], leadersWomen: [], search: '', runnerResult: {}, favorites: [], sortBy: initialState.rr360.sortBy, sortDir: initialState.rr360.sortDir});

    case SET_ACCOUNT_ID:
      return objectAssign({}, state, {accountId: action.accountId});

    case SET_ADS:
      return objectAssign({}, state, {ads: action.ads});

    case SET_THEME:
      return objectAssign({}, state, {theme: action.theme});

    case GET_RACES:
      return objectAssign({}, state, {races: action.races, sortBy: initialState.rr360.sortBy, sortDir: initialState.rr360.sortDir});

    case GET_RACE_DETAIL:
      return objectAssign({}, state, {raceDetail: action.raceDetail});

    case GET_LEADERBOARD_MEN:
      return objectAssign({}, state, {leadersMen: action.leadersMen});

    case GET_LEADERBOARD_WOMEN:
      return objectAssign({}, state, {leadersWomen: action.leadersWomen});

    case TOGGLE_FAVORITE:
      return objectAssign({}, state, {favorites: action.favorites});

    case GET_RESULTS:
       return objectAssign({}, state, {results: action.results, resultsTotal: action.resultsTotal, resultsPage: action.resultsPage});

    case SELECT_EVENT:
      return objectAssign({}, state, {eventId: action.eventId, sortBy: initialState.rr360.sortBy, sortDir: initialState.rr360.sortDir});

    case GET_RUNNER_RESULTS:
      return objectAssign({}, state, {runnerResult: action.runnerResult});

    case SEARCH_RESULTS: {

      const collectiveSearchResults = state.collectiveSearchResults === null ? action.searchResults : [...state.collectiveSearchResults.slice(0, action.start), ...action.searchResults];
      return objectAssign({}, state, {searchResults: action.searchResults, collectiveSearchResults, searchResultsTotal: action.searchResultsTotal, searchResultsPage: action.searchResultsPage, search: action.search, div: action.div});
    }

    case CHANGE_SORT:
      return objectAssign({}, state, {sortBy: action.sortBy, sortDir: action.sortDir});

    case SET_MOBILE:
      return objectAssign({}, state, {isMobile: action.isMobile});

    case SET_BRAND:
      return objectAssign({}, state, {brand: action.brand});

    case CLEAR_SEARCH_RESULTS:
      return objectAssign({}, state, {searchResults: null, searchResultsTotal: null, searchResultsPage: 0});

    case SET_SINGLE_EVENT:
      return objectAssign({}, state, {singleEvent: action.singleEvent});

    case STICKY_FULL:
      return objectAssign({}, state, {stickyFull: true});

    case UNAUTHORIZED:
      return objectAssign({}, state, {unauthorized: true});

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/rr360.js